import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectTenantInfo } from '@sophocles/features/tenant/slice';

const DisabledUserEmailNotifications = ({ confirm, disabledTime }) => {
  const { t } = useTranslation();
  const tenantInfo = useSelector(selectTenantInfo);

  return (
    <div>
      <p>
        Your email notification settings have been disabled because there was a problem delivering emails to your email
        address on {moment(disabledTime).format('L')}.
      </p>
      <p>
        If issues with your email address have been resolved, you can navigate to your{' '}
        <a href="#" onClick={confirm}>
          {t('auth.userProfileSettings', 'User Profile Settings')}
        </a>{' '}
        to reactivate your email notifications.
      </p>
      <br />
      <div style={{ fontSize: '14px', textAlign: 'center' }}>
        If you have any questions, please contact {tenantInfo.organization_name} support at
        <div>
          {tenantInfo.contact_phone} or {tenantInfo.contact_email}
        </div>
      </div>
    </div>
  );
};

export default DisabledUserEmailNotifications;
